import { IAPCLONEREASON, ProductQuoteOverrideViewModel } from 'bff';
import { ProposalInfoFlags } from 'modules/new-business/types/proposal/is-proposal-locked-return.type';

interface GetProposalLockedFlagsProp {
  cloneReason?: IAPCLONEREASON;
  isProposalLocked: boolean;
  isSpecialQuoteUser: boolean;
  overrides: ProductQuoteOverrideViewModel[] | undefined;
}

export const getProposalLockedFlags = ({
  cloneReason,
  isProposalLocked,
  isSpecialQuoteUser,
  overrides
}: GetProposalLockedFlagsProp): ProposalInfoFlags => {
  const isClonedForOverride = cloneReason === IAPCLONEREASON.Cloneforoverride;
  const isClonedForRequote = cloneReason === IAPCLONEREASON.Cloneforupdate;
  const isNotAClone = !isClonedForOverride && !isClonedForRequote;
  const isStepThreeUnlocked = isClonedForOverride && isSpecialQuoteUser && !isProposalLocked;
  const doesProductHaveOverrides = !!overrides && overrides.length >= 1;

  const result: ProposalInfoFlags = {
    isProposalClonedForRequote: isClonedForRequote,
    isOriginalProposal: isNotAClone,
    isStepThreeUnlocked: isStepThreeUnlocked,
    isProposalClonedForOverride: isClonedForOverride,
    isOverridePresentForOriginal: doesProductHaveOverrides,
    isProposalLocked: isProposalLocked
  };

  if (isClonedForRequote || isClonedForOverride) result.isProposalLocked = true;
  if (isNotAClone && doesProductHaveOverrides && !isSpecialQuoteUser)
    result.isProposalLocked = true;

  return result;
};
